import React from 'react';
import { HStack, Button } from '@chakra-ui/react';

// Navegación hacia las vistas de acciones por dictado.
// Las rutas corresponden a subvistas declaradas en routes.js:
//   /admin/dictated-courses/:id/list           (LISTA - inscriptos)
//   /admin/dictated-courses/:id/absences       (INASISTENCIAS)
//   /admin/dictated-courses/:id/teachers       (DOCENTES - asignación múltiple)
//   /admin/dictated-courses/:id/acta           (ACTA - resultados)
const DictatedCourseActions = ({ row }) => {
  const id = row?.original?.id;
  if (!id) return null;
  const go = (suffix) => (e) => {
    e.stopPropagation();
    // Uso window.location para evitar importar useNavigate dentro de un objeto.
    // Si se necesita history state, cambiar a react-router navigate.
    window.location.assign(`/admin/dictated-courses/${id}/${suffix}`);
  };
  return (
    <HStack spacing={1} onClick={(e) => e.stopPropagation()}>
      <Button size="xs" variant="outline" onClick={go('list')}>
        LISTA
      </Button>
      <Button size="xs" variant="outline" onClick={go('absences')}>
        INASISTENCIAS
      </Button>
      <Button size="xs" variant="outline" onClick={go('teachers')}>
        DOCENTES
      </Button>
      <Button size="xs" variant="outline" onClick={go('acta')}>
        ACTA
      </Button>
    </HStack>
  );
};

export const columnsDataDictatedCourses = [
  {
    Header: "Id",
    accessor: "id",
  },
  {
    Header: "Dictado",
    accessor: "subject.description",
  },
  {
    Header: "Estudio",
    accessor: "subject.study.description",
  },
  {
    Header: "Plan",
    accessor: "subject.studyPlan.description",
  },
  {
    Header: "Ciclo",
    accessor: "subject.cycle",
  },
  {
    Header: "Modalidad",
    accessor: "subject.obligatory",
    Cell: ({ row }) => {
      const s = row?.original?.subject;
      const obligatory = !!s?.obligatory;
      const hasExam = !!s?.exam;
      const hasPractic = !!s?.practic;

      if (obligatory) return "Obligatorio";
      if (hasExam && hasPractic) return "Exonerable";
      if (hasExam) return "Libre";
      return "—";
    },
  },
  // Se consolidan las 4 columnas de fechas (curso + inscripción) en 2 rangos
  // para reducir el ancho total de la grilla y asegurar que la columna
  // "Acciones" (LISTA / INASISTENCIAS / DOCENTES / ACTA) quede siempre
  // visible sin necesidad de scroll horizontal.
  {
    Header: "Curso",
    accessor: "startDate",
    Cell: ({ row }) => {
      const fmt = (v) => (v ? new Date(v).toLocaleDateString('es-ES') : '—');
      return `${fmt(row.original.startDate)} - ${fmt(row.original.endDate)}`;
    },
  },
  {
    Header: "Inscripción",
    accessor: "inscriptionStartDate",
    Cell: ({ row }) => {
      const fmt = (v) => (v ? new Date(v).toLocaleDateString('es-ES') : '—');
      return `${fmt(row.original.inscriptionStartDate)} - ${fmt(row.original.inscriptionEndDate)}`;
    },
  },
  // Columna "Precio" eliminada: el precio ya no vive en el dictado sino
  // en cada plan de pago asociado (ver `paymentPlans`). Mostrar un único
  // precio confunde con la nueva estructura.
  {
    Header: "Estado",
    accessor: "status",
    Cell: ({ row }) => {
      const now = new Date();
      const inscriptionStart = new Date(row.original.inscriptionStartDate);
      const inscriptionEnd = new Date(row.original.inscriptionEndDate);
      const courseStart = new Date(row.original.startDate);
      const courseEnd = new Date(row.original.endDate);

      if (now < inscriptionStart) {
        return "Próximamente";
      } else if (now >= inscriptionStart && now <= inscriptionEnd) {
        return "Inscripción abierta";
      } else if (now > inscriptionEnd && now < courseStart) {
        return "Inscripción cerrada";
      } else if (now >= courseStart && now <= courseEnd) {
        return "En curso";
      } else if (now > courseEnd) {
        return "Finalizado";
      }
      return "N/A";
    }
  },
  {
    Header: "Acciones",
    accessor: "dictatedActions",
    Cell: (info) => <DictatedCourseActions row={info.row} />,
  },
];
